import React from 'react'
import PropTypes from 'prop-types'
import { MenuIconWrapper } from './MenuIconStyled'

const MenuIcon = props => {
  const { children } = props
  return (
    <MenuIconWrapper>
      <div className="circle">
        <div className="outer-circle1"></div>
        <div className="outer-circle2"></div>
      </div>
      {children}
    </MenuIconWrapper>
  )
}

MenuIcon.propTypes = {}

export default MenuIcon